import React, { FC, PropsWithChildren } from 'react';

import auth from 'utils/auth';

import { LoggedInGlobalState } from './LoggedInGlobalState';

export const SetupGlobalState: FC<PropsWithChildren> = ({ children }) => {
  if (auth.isLoggedIn()) {
    return <LoggedInGlobalState>{children}</LoggedInGlobalState>;
  }
  return <>{children}</>;
};
